/*
 * @Author: 王一宁 wangyining@fenxiangbuy.com
 * @Date: 2024-08-06 14:15:11
 * @LastEditors: 王一宁 wangyining@fenxiangbuy.com
 * @LastEditTime: 2024-08-08 13:56:54
 * @FilePath: /shengsheng-client/src/main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { postEvent } from "./api/system";
import "vant/lib/index.css";
import "./assets/styles/tailwind.css";
import "./assets/styles/smile-order-fonts.css";
import "./assets/styles/rem-base.css";
import { initRemAdaptation } from "./utils/rem";

const disposeRemAdaptation = initRemAdaptation();
if (module.hot) module.hot.dispose(disposeRemAdaptation);

Promise.resolve()
  .then(() =>
    postEvent({
      eventType: 2001,
      businessId: 0,
    }),
  )
  .catch(() => undefined);

createApp(App).use(store).use(router).mount("#app");
